import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    telNumber:"",
    userName:""
  },
  mutations: {
    telNumber(state, data){
      state.telNumber = data
    },
    setUserName(state, data){
      state.userName = data
    },
  },
  actions: {
  },
  modules: {
  }
})
